module.exports = __webpack_public_path__ + "static/media/rtc.b95ff773.svg";